import React from "react"
import ReactDOM from "react-dom"
import { registerFormPopupElement } from "./web-component/registerFormPopupElement"

// Expose React on window for the standalone IIFE build
window.React = React
window.ReactDOM = ReactDOM

registerFormPopupElement()

export { default as FormPopup } from "./FormPopup/FormPopup"
export type { FormPopupProps, FormType, CommunicationConsent } from "./FormPopup/types"
